<template>
  <div>
    <!-- v-model="match" -->
    <Modal
      class="match-circuit-modal"
      :styles="{ top: '20px', width: 'auto', maxWidth: '830px' }"
      :value="true"
      title="Match Modal"
      :closable="false"
      :mask-closable="false"
    >
      <div
        slot="header"
        class="d-flex justify-content-between align-items-center"
      >
        <h5 style="margin-bottom: 0;">
          {{ $t("club.table.stats") }} | {{ match.home_team.name }} -
          {{ match.away_team.name }}
        </h5>
        <Button
          @click="() => $emit('close', changesHappened)"
          type="text"
          icon="md-close"
          class="modal-close-btn"
        ></Button>
      </div>
      <Alert v-if="serverError.length" type="error"> {{ serverError }} </Alert>
      <Spin v-if="loading" fix>
        <Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
        <div>{{ $t("global.loading") }}</div>
      </Spin>

      <div style="margin-bottom: 10px; text-align: center;">
        <Card :bordered="false">
          <template>
            <div class="d-flex align-items-center">
              <DatePicker
                v-if="!disabled"
                v-model="matchStartDate"
                :disabled="disabled"
                :placeholder="$t('club.table.date')"
                style="width: 200px;"
                @on-change="onChangeDates"
                format="dd-MM-yyyy"
                clearable
              ></DatePicker>
              <h5 v-else>
                {{ $moment(matchStartDate).format("DD MMM YYYY") }}
              </h5>
              <span v-if="matchStartDate" class="ml-1 mr-1"> - </span>
              <TimePicker
                v-if="!disabled"
                v-model="matchStartHour"
                :disabled="disabled"
                type="time"
                :value="valueTimePicker"
                format="HH:mm"
                style="width: 145px;"
                :placeholder="$t('global.time')"
                @on-change="onChangeHours"
                clearable
              >
              </TimePicker>
              <h5 v-else>{{ matchStartHour }}</h5>
              <span v-if="matchStartHour" class="ml-1 mr-1"> - </span>
              <Input
                v-if="!disabled"
                v-model="matchStadium"
                :disabled="disabled"
                placeholder="Denumirea terenului"
                class="ml-3 mr-3"
              />
              <h5 v-else>{{ matchStadium }}</h5>
              <Button
                v-if="!disabled"
                type="success"
                class="md-checkmark-style"
                @click="onSaveMatchStats(match)"
                :disabled="disabled"
              >
                <b>{{ $t("competition.save_match") }}</b>
              </Button>
            </div>
          </template>
        </Card>
      </div>

      <div class="table-special-div">
        <table
          v-if="!loading"
          class="table table-bordered dt-responsive table-striped nowrap w-100 ml-0"
        >
          <thead>
            <tr>
              <th>
                {{ $t("user.table.name") }} /{{ $t("user.table.surname") }}
              </th>
              <th>{{ $t("competition.drop_goals") }}</th>
              <th>{{ $t("competition.goals") }}</th>
              <th>{{ $t("competition.executions") }}</th>
              <th style="width: 100px; max-width: 100px;">
                <span>{{ $t("competition.scored") }}</span>
              </th>
              <th>{{ $t("competition.yellows") }}</th>
              <th>{{ $t("competition.reds") }}</th>
              <th style="width: 190px; max-width: 190px;">
                {{ $t("driver.description") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                class="font-weight-bold"
                colspan="6"
                style="vertical-align: middle; height: 43px; min-height: 43px;"
              >
                {{ match.home_team.name }}
              </td>
              <td class="font-weight-bold" colspan="2">
                <Button
                  v-if="!disabled"
                  type="primary"
                  class="md-checkmark-style"
                  @click="onTechLoser('home_team', match)"
                  long
                  :disabled="disabled"
                >
                  <span
                    class="d-flex align-items-center justify-content-center"
                  >
                    <i
                      v-if="
                        match.tech_loser &&
                          match.tech_loser === match.home_team._id
                      "
                      class="bx bxs-check-circle mr-2"
                      style="font-size: 18px; color: #19be6b;"
                    ></i>
                    {{ $t("menu.technical_defeat") }}
                  </span>
                </Button>
                <Alert
                  v-if="
                    disabled &&
                      match.tech_loser &&
                      match.tech_loser === match.home_team._id
                  "
                  type="error"
                  class="text-center modal-alert-style"
                  style="padding: 6px;"
                  >{{ $t("menu.technical_defeat") }}</Alert
                >
              </td>
            </tr>
            <template v-for="(player, idx) in match.home_players">
              <tr :key="player.player._id">
                <td
                  :style="
                    isPlayerDisqualified(match.home_team, player.player)
                      ? 'height: 43px'
                      : ''
                  "
                >
                  <div class="d-flex align-items-center position-relative">
                    <Tooltip
                      :content="
                        player.player.firstName + ' ' + player.player.secondName
                      "
                      placement="top-start"
                      class="w-100"
                    >
                      <span
                        class="text-overflow-style single-groups-clamp-text"
                      >
                        {{ player.player.firstName }}
                        <br />
                        {{ player.player.secondName }}
                      </span>
                    </Tooltip>
                    <span
                      v-if="
                        isPlayerDisqualified(match.home_team, player.player)
                      "
                      style="position: absolute; right: 0;"
                    >
                      <Button
                        class="player-color-card player-red-card"
                        disabled
                      ></Button>
                    </span>
                  </div>
                </td>
                <td class="text-center">
                  <InputNumber
                    v-if="!disabled"
                    v-model="player.drop_goals"
                    :disabled="
                      disabled ||
                        isPlayerDisqualified(match.home_team, player.player)
                    "
                    :min="+0"
                    style="max-width: 58px;"
                    placeholder="0"
                  >
                  </InputNumber>
                  <h5 v-else>
                    {{ player.drop_goals ? player.drop_goals : 0 }}
                  </h5>
                </td>
                <td class="text-center">
                  <InputNumber
                    v-if="!disabled"
                    v-model="player.goals"
                    :disabled="
                      disabled ||
                        isPlayerDisqualified(match.home_team, player.player)
                    "
                    :min="+0"
                    style="max-width: 58px;"
                    placeholder="0"
                  >
                  </InputNumber>
                  <h5 v-else>{{ player.goals }}</h5>
                </td>
                <td class="text-center">
                  <InputNumber
                    v-if="!disabled"
                    v-model="player.executions"
                    :disabled="
                      disabled ||
                        isPlayerDisqualified(match.home_team, player.player)
                    "
                    :min="+0"
                    style="max-width: 58px;"
                    placeholder="0"
                  >
                  </InputNumber>
                  <h5 v-else>
                    {{ player.executions ? player.executions : 0 }}
                  </h5>
                </td>
                <td class="text-center">
                  <InputNumber
                    v-if="!disabled"
                    v-model="player.points"
                    :disabled="
                      disabled ||
                        isPlayerDisqualified(match.home_team, player.player)
                    "
                    :min="+0"
                    style="max-width: 58px;"
                    placeholder="0"
                  >
                  </InputNumber>
                  <h5 v-else>{{ player.points }}</h5>
                </td>
                <td>
                  <span class="d-none"> </span>
                  <div>
                    <div v-if="!disabled" class="add-button-block mb-2">
                      <Button
                        @click="addCards('yellow', player)"
                        type="warning"
                        :key="idx"
                        :disabled="
                          (player.cards &&
                            player.cards.filter(
                              item => item.card_type === 'yellow'
                            ).length >= 2) ||
                            disabled ||
                            isPlayerDisqualified(match.home_team, player.player)
                        "
                        icon="md-add"
                        long
                      ></Button>
                    </div>

                    <div
                      v-if="player.cards && player.cards.length > 0"
                      class="d-flex justify-content-center align-items-center"
                    >
                      <template v-for="(card, index) in player.cards">
                        <Poptip
                          v-if="card.card_type === 'yellow'"
                          trigger="hover"
                          placement="top"
                          width="400"
                          class="mr-1"
                        >
                          <Button
                            class="player-color-card player-yellow-card"
                            :disabled="
                              disabled ||
                                isPlayerDisqualified(
                                  match.home_team,
                                  player.player
                                )
                            "
                          >
                            <div v-if="!disabled">
                              <i
                                v-if="
                                  !disabled ||
                                    isPlayerDisqualified(
                                      match.home_team,
                                      player.player
                                    )
                                "
                                class="bx bxs-trash"
                                style="font-size: 15px; color: #ff0000;"
                                @click="handleRemoveCards(index, player.cards)"
                              ></i>
                            </div>
                          </Button>
                          <div class="api" slot="content">
                            <Input
                              v-model="card.comment"
                              type="textarea"
                              :disabled="
                                disabled ||
                                  isPlayerDisqualified(
                                    match.home_team,
                                    player.player
                                  )
                              "
                              placeholder="Enter something..."
                            ></Input>
                          </div>
                        </Poptip>
                      </template>
                    </div>
                  </div>
                </td>
                <td>
                  <span class="d-none"> </span>
                  <div>
                    <div v-if="!disabled" class="add-button-block mb-2">
                      <Button
                        @click="addCards('red', player)"
                        type="error"
                        :key="idx"
                        :disabled="
                          (player.cards &&
                            player.cards.filter(
                              item => item.card_type === 'red'
                            ).length >= 1) ||
                            disabled ||
                            isPlayerDisqualified(match.home_team, player.player)
                        "
                        icon="md-add"
                        long
                      ></Button>
                    </div>

                    <div
                      v-if="player.cards && player.cards.length > 0"
                      class="d-flex justify-content-center align-items-center"
                    >
                      <template v-for="(card, index) in player.cards">
                        <Poptip
                          v-if="card.card_type === 'red'"
                          trigger="hover"
                          placement="top"
                          width="400"
                          class="mr-1"
                        >
                          <Button
                            class="player-color-card player-red-card"
                            :disabled="
                              disabled ||
                                isPlayerDisqualified(
                                  match.home_team,
                                  player.player
                                )
                            "
                          >
                            <div v-if="!disabled">
                              <i
                                v-if="
                                  !disabled ||
                                    isPlayerDisqualified(
                                      match.home_team,
                                      player.player
                                    )
                                "
                                class="bx bxs-trash"
                                style="font-size: 15px; color: #ffffff;"
                                @click="handleRemoveCards(index, player.cards)"
                              ></i>
                            </div>
                          </Button>
                          <div class="api" slot="content">
                            <Input
                              v-model="card.comment"
                              type="textarea"
                              :disabled="
                                disabled ||
                                  isPlayerDisqualified(
                                    match.home_team,
                                    player.player
                                  )
                              "
                              placeholder="Enter something..."
                            ></Input>
                          </div>
                        </Poptip>
                        <div>
                          <InputNumber
                            :disabled="
                              disabled ||
                                isPlayerDisqualified(
                                  match.home_team,
                                  player.player
                                )
                            "
                            v-if="card.card_type === 'red' && !disabled"
                            v-model="card.suspend_matches"
                            :value="+1"
                            :min="+1"
                            style="max-width: 58px;"
                            placeholder="0"
                          >
                          </InputNumber>
                          <h5
                            v-else-if="card.card_type === 'red' && disabled"
                            class="ml-2"
                          >
                            {{ card.suspend_matches }}
                          </h5>
                        </div>
                      </template>
                    </div>
                  </div>
                </td>
                <td>
                  <Input
                    v-if="!disabled"
                    v-model="player.notes"
                    :disabled="
                      disabled ||
                        isPlayerDisqualified(match.home_team, player.player)
                    "
                    type="textarea"
                    placeholder="Enter something..."
                  ></Input>
                  <Tooltip
                    v-else
                    :content="player.notes"
                    placement="top-start"
                    class="w-100"
                  >
                    <span class="text-overflow-style single-groups-clamp-text">
                      {{ player.notes }}
                    </span>
                  </Tooltip>
                </td>
              </tr>
            </template>
            <tr>
              <td colspan="6" class="disabled-border-tr"></td>
            </tr>
            <tr>
              <td
                class="font-weight-bold"
                colspan="6"
                style="vertical-align: middle; height: 43px;"
              >
                {{ match.away_team.name }}
              </td>
              <td class="font-weight-bold" colspan="2">
                <Button
                  v-if="!disabled"
                  type="primary"
                  class="md-checkmark-style"
                  :disabled="disabled"
                  @click="onTechLoser('away_team', match)"
                  long
                >
                  <span
                    class="d-flex align-items-center justify-content-center"
                  >
                    <i
                      v-if="
                        match.tech_loser &&
                          match.tech_loser === match.away_team._id
                      "
                      class="bx bxs-check-circle mr-2"
                      style="font-size: 18px; color: #19be6b;"
                    ></i>
                    {{ $t("menu.technical_defeat") }}
                  </span>
                </Button>
                <Alert
                  v-if="
                    disabled &&
                      match.tech_loser &&
                      match.tech_loser === match.away_team._id
                  "
                  type="error"
                  class="text-center modal-alert-style"
                  style="padding: 6px;"
                  >{{ $t("menu.technical_defeat") }}</Alert
                >
              </td>
            </tr>
            <template v-for="(player, ind) in match.away_players">
              <tr :key="player.player._id">
                <td
                  :style="
                    isPlayerDisqualified(match.away_team, player.player)
                      ? 'height: 43px'
                      : ''
                  "
                >
                  <div class="d-flex align-items-center position-relative">
                    <Tooltip
                      :content="
                        player.player.firstName + ' ' + player.player.secondName
                      "
                      placement="top-start"
                      class="w-100"
                    >
                      <span
                        class="text-overflow-style single-groups-clamp-text"
                      >
                        {{ player.player.firstName }}
                        {{ player.player.secondName }}
                      </span>
                    </Tooltip>
                    <span
                      v-if="
                        isPlayerDisqualified(match.away_team, player.player)
                      "
                      style="position: absolute; right: 0;"
                    >
                      <Button
                        class="player-color-card player-red-card"
                        disabled
                      ></Button>
                    </span>
                  </div>
                </td>
                <td class="text-center">
                  <InputNumber
                    v-if="!disabled"
                    v-model="player.drop_goals"
                    :disabled="
                      disabled ||
                        isPlayerDisqualified(match.away_team, player.player)
                    "
                    :value="+0"
                    :min="+0"
                    style="max-width: 58px;"
                    placeholder="0"
                  >
                  </InputNumber>
                  <h5 v-else>{{ player.drop_goals }}</h5>
                </td>
                <td class="text-center">
                  <InputNumber
                    v-if="!disabled"
                    v-model="player.goals"
                    :disabled="
                      disabled ||
                        isPlayerDisqualified(match.away_team, player.player)
                    "
                    :value="+0"
                    :min="+0"
                    style="max-width: 58px;"
                    placeholder="0"
                  >
                  </InputNumber>
                  <h5 v-else>{{ player.goals }}</h5>
                </td>
                <td class="text-center">
                  <InputNumber
                    v-if="!disabled"
                    v-model="player.executions"
                    :disabled="
                      disabled ||
                        isPlayerDisqualified(match.away_team, player.player)
                    "
                    :value="+0"
                    :min="+0"
                    style="max-width: 58px;"
                    placeholder="0"
                  >
                  </InputNumber>
                  <h5 v-else>{{ player.executions }}</h5>
                </td>
                <td class="text-center">
                  <InputNumber
                    v-if="!disabled"
                    v-model="player.points"
                    :disabled="
                      disabled ||
                        isPlayerDisqualified(match.away_team, player.player)
                    "
                    :value="+0"
                    :min="+0"
                    style="max-width: 58px;"
                    placeholder="0"
                  >
                  </InputNumber>
                  <h5 v-else>{{ player.points }}</h5>
                </td>
                <td>
                  <span class="d-none"> </span>
                  <div>
                    <div v-if="!disabled" class="add-button-block mb-2">
                      <Button
                        @click="addCards('yellow', player)"
                        type="warning"
                        :key="ind"
                        :disabled="
                          (player.cards &&
                            player.cards.filter(
                              item => item.card_type === 'yellow'
                            ).length >= 2) ||
                            disabled ||
                            isPlayerDisqualified(match.away_team, player.player)
                        "
                        icon="md-add"
                        long
                      ></Button>
                    </div>

                    <div
                      v-if="player.cards && player.cards.length > 0"
                      class="d-flex justify-content-center align-items-center"
                    >
                      <template v-for="(card, index) in player.cards">
                        <Poptip
                          v-if="card.card_type === 'yellow'"
                          trigger="hover"
                          placement="top"
                          width="400"
                          class="mr-1"
                        >
                          <Button
                            class="player-color-card player-yellow-card"
                            :disabled="
                              disabled ||
                                isPlayerDisqualified(
                                  match.away_team,
                                  player.player
                                )
                            "
                          >
                            <div v-if="!disabled">
                              <i
                                v-if="
                                  !disabled ||
                                    isPlayerDisqualified(
                                      match.away_team,
                                      player.player
                                    )
                                "
                                class="bx bxs-trash"
                                style="font-size: 15px; color: #ff0000;"
                                @click="handleRemoveCards(index, player.cards)"
                              ></i>
                            </div>
                          </Button>
                          <div class="api" slot="content">
                            <Input
                              v-model="card.comment"
                              type="textarea"
                              :disabled="
                                disabled ||
                                  isPlayerDisqualified(
                                    match.away_team,
                                    player.player
                                  )
                              "
                              placeholder="Enter something..."
                            ></Input>
                          </div>
                        </Poptip>
                      </template>
                    </div>
                  </div>
                </td>
                <td>
                  <span class="d-none"> </span>
                  <div>
                    <div v-if="!disabled" class="add-button-block mb-2">
                      <Button
                        @click="addCards('red', player)"
                        type="error"
                        :key="ind"
                        :disabled="
                          (player.cards &&
                            player.cards.filter(
                              item => item.card_type === 'red'
                            ).length >= 1) ||
                            disabled ||
                            isPlayerDisqualified(match.away_team, player.player)
                        "
                        icon="md-add"
                        long
                      ></Button>
                    </div>

                    <div
                      v-if="player.cards && player.cards.length > 0"
                      class="d-flex justify-content-center align-items-center"
                    >
                      <template v-for="(card, index) in player.cards">
                        <Poptip
                          v-if="card.card_type === 'red'"
                          trigger="hover"
                          placement="top"
                          width="400"
                          class="mr-1"
                        >
                          <Button
                            class="player-color-card player-red-card"
                            :disabled="
                              disabled ||
                                isPlayerDisqualified(
                                  match.away_team,
                                  player.player
                                )
                            "
                          >
                            <div v-if="!disabled">
                              <i
                                v-if="
                                  !disabled ||
                                    isPlayerDisqualified(
                                      match.away_team,
                                      player.player
                                    )
                                "
                                class="bx bxs-trash"
                                style="font-size: 15px; color: #ffffff;"
                                @click="handleRemoveCards(index, player.cards)"
                              ></i>
                            </div>
                          </Button>
                          <div class="api" slot="content">
                            <Input
                              v-model="card.comment"
                              type="textarea"
                              :disabled="
                                disabled ||
                                  isPlayerDisqualified(
                                    match.away_team,
                                    player.player
                                  )
                              "
                              placeholder="Enter something..."
                            ></Input>
                          </div>
                        </Poptip>
                        <InputNumber
                          :disabled="
                            disabled ||
                              isPlayerDisqualified(
                                match.away_team,
                                player.player
                              )
                          "
                          v-if="card.card_type === 'red' && !disabled"
                          v-model="card.suspend_matches"
                          :value="+1"
                          :min="+1"
                          style="max-width: 58px;"
                          placeholder="0"
                        >
                        </InputNumber>
                        <h5
                          v-else-if="card.card_type === 'red' && disabled"
                          class="ml-2"
                        >
                          {{ card.suspend_matches }}
                        </h5>
                      </template>
                    </div>
                  </div>
                </td>
                <td>
                  <Input
                    v-if="!disabled"
                    v-model="player.notes"
                    :disabled="
                      disabled ||
                        isPlayerDisqualified(match.away_team, player.player)
                    "
                    type="textarea"
                    placeholder="Enter something..."
                  ></Input>
                  <Tooltip
                    v-else
                    :content="player.notes"
                    placement="top-start"
                    class="w-100"
                  >
                    <span class="text-overflow-style single-groups-clamp-text">
                      {{ player.notes }}
                    </span>
                  </Tooltip>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div slot="footer" class="d-flex">
        <Button
          v-if="!match.isFinished"
          type="error"
          class="md-checkmark-style mb-2"
          @click="cancelMatch"
          style="width: 50%;"
          :disabled="disabled"
        >
          <b>{{ $t("competition.cancel_match") }}</b>
        </Button>
        <Button
          v-if="!match.isFinished"
          type="info"
          class="md-checkmark-style mb-2"
          @click="endMatches(match)"
          style="width: 50%;"
          :disabled="match.isFinished || (match.round.isPlayoff && isDraw)"
        >
          <b>{{ $t("competition.end_match") }}</b>
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { match } from "assert";

export default {
  name: "MatchCircuitModal",
  props: ["match", "competition"],
  data() {
    return {
      serverError: [],
      players: [],
      loading: false,
      playerNotice: "",
      cardNotice: "",
      valueTimePicker: ["Hour", "Minutes"],
      matchStartDate: "",
      matchStartHour: "",
      isDraw: false,
      matchStadium: "",
      specialCompetitionType: [
        "657ae21d7f55d47e29ec1852",
        "657ae2187f55d47e29ec1850"
      ],
      disabled: false,
      changesHappened: false
    };
  },
  watch: {
    match(newMatch) {
      if (newMatch.isFinished) {
        this.$emit("getCurrentTeams");
      }
    },
    "match.home_players": {
      deep: true,
      handler(n) {
        if (this.getPoints(n) === this.getPoints(this.match.away_players)) {
          this.isDraw = true;
        } else {
          this.isDraw = false;
        }
      }
    },
    "match.away_players": {
      deep: true,
      handler(n) {
        if (this.getPoints(n) === this.getPoints(this.match.home_players)) {
          this.isDraw = true;
        } else {
          this.isDraw = false;
        }
      }
    }
  },
  methods: {
    getPoints(players) {
      let sum = 0;
      for (const player of players) {
        sum += player.points;
      }
      return sum;
    },
    isPlayerDisqualified(team, inputPlayer) {
      const result = team.players.find(
        teamPlayer => teamPlayer.player._id === inputPlayer._id
      );
      if (result && result.isDisqualified) {
        return true;
      }
      return false;
    },
    async onTechLoser(keys, team) {
      const teamObj = {
        _id: team._id,
        isFinished: true,
        tech_loser:
          keys === "home_team" ? team.home_team._id : team.away_team._id
      };

      const teamName =
        keys === "home_team" ? team.home_team.name : team.away_team.name;

      this.$dialog
        .confirm(this.$t("global.on_tehloose_confirm", { msg: teamName }), {
          okText: this.$t("global.yes"),
          cancelText: this.$t("global.no"),
          html: true,
          customClass: "mahnung-confirm"
        })
        .then(async _dialog => {
          try {
            this.loading = true;
            const res = await this.$http
              .post("/match/edit", { ...teamObj })
              .then(response => {
                setTimeout(() => {
                  // this.loading = false;
                  this.$emit("close", true);
                }, 1000);
              });
          } catch (error) {
            console.log("erro onTechLoser", error);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    onChangeDates(e) {
      const [day, month, year] = e.split("-");
      console.log({ day, month, year });
      this.matchStartDate = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
      console.log("matchStartDate", this.matchStartDate, e);
    },
    onChangeHours(e) {
      const hours = e.split(":");
      if (this.matchStartDate) {
        this.matchStartDate.setHours(hours[0], hours[1]);
      }
    },
    async cancelMatch() {
      const matchObj = {
        _id: this.match._id,
        isFinished: true,
        isCancelled: true,
        start_date: this.matchStartDate
          ? this.matchStartDate
          : this.match.stage.date_start
      };

      this.$dialog
        .confirm(this.$t("competition.cancel_match"), {
          okText: this.$t("global.yes"),
          cancelText: this.$t("global.no"),
          html: true,
          customClass: "mahnung-confirm"
        })
        .then(async _dialog => {
          try {
            this.loading = true;
            // this.onSaveMatchStats(element);
            const res = await this.$http
              .post("/match/edit", { ...matchObj })
              .then(response => {
                setTimeout(() => {
                  // this.loading = false;
                  this.$emit("close", true);
                }, 1000);
              });
          } catch (error) {
            console.log("erro endMatches", error);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    async endMatches(element) {
      const matchObj = {
        _id: element._id,
        isFinished: true
      };

      this.$dialog
        .confirm(this.$t("competition.end_match"), {
          okText: this.$t("global.yes"),
          cancelText: this.$t("global.no"),
          html: true,
          customClass: "mahnung-confirm"
        })
        .then(async _dialog => {
          try {
            this.loading = true;
            this.onSaveMatchStats(element);
            const res = await this.$http
              .post("/match/edit", { ...matchObj })
              .then(response => {
                setTimeout(() => {
                  // this.loading = false;
                  this.$emit("close", true);
                }, 1000);
              });
          } catch (error) {
            console.log("erro endMatches", error);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleRemoveCards(index, playerCards) {
      playerCards.splice(index, 1);
    },
    checkIfDisabled() {
      if (this.match.isCancelled) {
        this.disabled = true;
      } else if (this.$user.data.role.includes("super")) {
        this.disabled = false;
      } else if (this.match.isFinished) {
        this.disabled = true;
      }
    },
    addCards(color, player) {
      let arr = [...player.cards];
      let cardsObj = {
        card_type: color,
        comment: "",
        suspend_matches: color === "red" ? 1 : 0
      };

      arr.push(cardsObj);

      const yellowCard = arr.filter(item => item.card_type === "yellow");
      const redCard = arr.filter(item => item.card_type === "red");

      if (yellowCard.length >= 2) {
        let reds = {
          card_type: "red",
          comment: "",
          suspend_matches: 1
        };
        arr = redCard.length >= 1 ? [...arr] : [...arr, reds];
      }

      player.cards = [...arr];
    },

    getHomeGoalsByPlayer(array, player) {
      return (player.home_points = array.filter(
        goal => goal.player._id === player._id
      ).length);
    },
    getAwayGoalsByPlayer(array, player) {
      return (player.away_points = array.filter(
        goal => goal.player._id === player._id
      ).length);
    },
    getCardsByPlayer(array, player, card) {
      return array.filter(
        cards => cards.player._id === player._id && cards.card_type === card
      ).length;
    },
    async getPlayersOfTeam() {
      try {
        this.loading = true;
        const res = await this.$http.post("/team/find", { _id: this.team._id });
        if (res.data && res.data.players.length) {
          let players = res.data.players.map(id => {
            return { jersey: id.jersey_number, ...id.player };
          });
          this.players = players;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getGoalsByStages() {
      this.loading = true;
      for (let i = 0; i < this.competition.stages.length; i++) {
        const element = this.competition.stages[i];
        try {
          const res = await this.$http.post("/team/stages", {
            teamId: this.team._id,
            stageId: element._id
          });
          for (let k = 0; k < this.players.length; k++) {
            if (res.data.find(data => data._id._id === this.players[k]._id))
              this.players[k][
                element.name.replace(" ", "_") + "_Goals"
              ] = res.data.find(
                data => data._id._id === this.players[k]._id
              ).goalsCount;
            else this.players[k][element.name.replace(" ", "_") + "_Goals"] = 0;
          }
        } catch (error) {
          console.log(error);
        }
      }
      this.loading = false;
    },
    async onSaveMatchStats(element) {
      console.log(this.matchStartDate);
      let homePlayers = [];
      for (let i = 0; i < element.home_players.length; i++) {
        const playerHome = {
          player: element.home_players[i].player._id,
          goals: element.home_players[i].goals,
          drop_goals: element.home_players[i].drop_goals,
          executions: element.home_players[i].executions,
          points: element.home_players[i].points,
          cards: element.home_players[i].cards,
          notes: element.home_players[i].notes
        };
        homePlayers.push(playerHome);
      }

      let awayPlayers = [];
      for (let i = 0; i < element.away_players.length; i++) {
        const playerAway = {
          player: element.away_players[i].player._id,
          goals: element.away_players[i].goals,
          drop_goals: element.away_players[i].drop_goals,
          executions: element.away_players[i].executions,
          points: element.away_players[i].points,
          cards: element.away_players[i].cards,
          notes: element.away_players[i].notes
        };
        awayPlayers.push(playerAway);
      }

      const matchObj = {
        _id: element._id,
        home_team: element.home_team._id,
        away_team: element.away_team._id,
        home_players: [...homePlayers],
        away_players: [...awayPlayers],
        start_date: this.matchStartDate
          ? this.matchStartDate
          : element.stage.date_start,
        stadium: this.matchStadium
        // isFinished: true,
      };

      try {
        this.loading = true;
        const res = await this.$http
          .post("/match/edit", { ...matchObj })
          .then(response => {
            setTimeout(() => {
              this.changesHappened = true;
              this.loading = false;
            }, 1000);
          });
      } catch (error) {
        console.log("erro onSaveMatchStats", error);
      }
    }
  },
  async mounted() {
    console.log(this.match);
    if (this.match) {
      for (let i = 0; i < this.match.home_players.length; i++) {
        this.match.home_players[i].cards = this.match.home_players[i].cards
          ? this.match.home_players[i].cards
          : [];
      }

      for (let i = 0; i < this.match.away_players.length; i++) {
        this.match.away_players[i].cards = this.match.away_players[i].cards
          ? this.match.away_players[i].cards
          : [];
      }

      this.match.home_players = this.match.home_players.sort((a, b) => {
        let AfullName = a.player.firstName + a.player.secondName;
        let BfullName = b.player.firstName + b.player.secondName;
        return AfullName.localeCompare(BfullName);
      });
      this.match.away_players = this.match.away_players.sort((a, b) => {
        let AfullName = a.player.firstName + a.player.secondName;
        let BfullName = b.player.firstName + b.player.secondName;
        return AfullName.localeCompare(BfullName);
      });

      if (this.match.start_date) {
        const dateStart = new Date(this.match.start_date);
        console.log(dateStart);
        let startHours = dateStart.getHours();
        let startMinutes = dateStart.getMinutes();
        console.log(startHours, startMinutes);
        if (startHours.toString().length === 1) startHours = "0" + startHours;
        if (startMinutes.toString().length === 1)
          startMinutes = "0" + startMinutes;
        this.matchStartHour = startHours + ":" + startMinutes;
        this.matchStartDate = new Date(this.match.start_date);
      } else {
        this.matchStartDate = "";
        this.matchStartHour = "";
      }
      const ifSpecialComp = this.specialCompetitionType.some(
        item => item === this.competition.ttype._id
      );
      this.matchStadium =
        ifSpecialComp || this.match.stadium
          ? this.match.stadium
          : this.match.stage.stadium;
      this.checkIfDisabled();
    }
    console.log("match :>> ", this.match);
  }
};
</script>

<style>
.modal-close-btn {
  padding: 0 5px;
  font-size: 20px;
}
</style>

<style scoped>
.add-button-block {
  height: 15px;
}

.add-button-block > .ivu-btn {
  padding: 0 !important;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
}

.player-color-card {
  width: 23px;
  height: 30px;
  padding: 0 !important;
  position: relative;
  overflow: hidden;
}

.match-circuit-modal .player-yellow-card {
  background: #ffe600 !important;
}

.player-color-card .bx.bxs-trash {
  position: absolute;
  right: 0;
  bottom: 0;
  display: none;
  padding: 3px 0 0 3px;
  border-top-left-radius: 10px;
}

.player-color-card:hover .bx.bxs-trash {
  display: inline-block;
}

.match-circuit-modal .player-color-card .bx.bxs-trash:hover {
  background: #c6c6c6 !important;
}

.match-circuit-modal .player-red-card {
  background: #ff0000 !important;
}

.match-circuit-modal .player-color-card.player-red-card .bx.bxs-trash:hover {
  color: #ff0000 !important;
}

.match-circuit-modal .player-yellow-card:hover,
.match-circuit-modal .player-red-card:hover {
  filter: none !important;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

.card-suspend-block,
.card-suspend-block :global(.ivu-input-number) {
  position: relative;
}

.match-circuit-modal :global(.ivu-modal-header) {
  padding-bottom: 0;
}

.match-circuit-modal :global(.ivu-modal-header),
.match-circuit-modal :global(.ivu-modal-footer) {
  border-color: transparent;
}

.match-circuit-modal :global(.ivu-input) {
  border-color: #333333;
}

.match-circuit-modal :global(.ivu-input-number) {
  border-color: #333333;
  background-color: #333333;
}

.card-suspend-block > small {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  font-size: 11px;
}

.match-circuit-modal table {
  font-size: small;
  table-layout: fixed;
}

.match-circuit-modal table td,
.match-circuit-modal table th {
  padding: 0.35rem;
  border-color: #333333 !important;
  vertical-align: middle;
  word-break: break-word;
}

.match-circuit-modal h5,
.match-circuit-modal table td,
.match-circuit-modal table th {
  color: #ffffff !important;
}

.match-circuit-modal :global(*[disabled]) {
  color: #ffffff !important;
}

.match-circuit-modal :global(.ivu-input-number-input),
.match-circuit-modal button,
.match-circuit-modal :global(.ivu-card-body input),
.match-circuit-modal :global(.ivu-card-body),
.match-circuit-modal :global(.ivu-input-wrapper textarea) {
  background: #454751 !important;
  color: #ffffff !important;
}

.match-circuit-modal :global(.ivu-card-body) {
  padding: 10px !important;
}

.match-circuit-modal .table-striped tbody tr:nth-of-type(odd) {
  background: #3d3f48 !important;
}

.match-circuit-modal .table-striped tbody tr:nth-of-type(odd):hover,
.match-circuit-modal tbody tr:hover {
  background: #555862 !important;
}

.match-circuit-modal button:hover {
  filter: brightness(0.8);
  color: #ffffff !important;
}

.match-circuit-modal :global(.ivu-select-dropdown),
.match-circuit-modal :global(.ivu-modal-content) {
  background: #454751;
  border: 1px solid #272727;
}

.match-circuit-modal :global(.ivu-modal-mask) {
  opacity: 0.8 !important;
  background-color: #000;
}

.match-circuit-modal :global(.ivu-poptip-body) {
  background: #1e1f24;
}

.match-circuit-modal :global(.ivu-poptip-popper .ivu-poptip-arrow),
.match-circuit-modal :global(.ivu-poptip-popper .ivu-poptip-arrow:after) {
  border-top-color: #1e1f24 !important;
}

.modal-alert-style {
  background: #454751 !important;
  color: #ffb08f !important;
  margin: 0;
}

.text-overflow-style {
  width: 100%;
}
.match-circuit-modal h5 {
  color: #ffffff !important;
  margin-bottom: 0;
}

.match-circuit-modal :global(.ivu-tooltip-inner) {
  /* max-width: 100%; */
  text-wrap: balance;
}

.match-circuit-modal :global(.ivu-spin) {
  background: #454751 !important;
  color: #ffffff;
}

.match-circuit-modal tr .disabled-border-tr {
  background: #454751;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
}

@media only screen and (max-width: 575.98px) {
  .match-circuit-modal :global(.ivu-modal) {
    margin: 10px auto !important;
    width: 100% !important;
  }
  .match-circuit-modal :global(.ivu-tooltip) {
    width: 110px !important;
    min-width: 110px !important;
  }
}

@media only screen and (max-width: 767.98px) {
  .match-circuit-modal :global(.ivu-modal-header) {
    padding: 10px 10px 0;
  }

  .match-circuit-modal :global(.ivu-modal-body) {
    padding: 10px;
    overflow-x: hidden;
  }

  .match-circuit-modal .table-stats {
    margin-bottom: 0;
  }

  .table-special-div {
    overflow-x: scroll;
  }

  .match-circuit-modal table {
    table-layout: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/schemes/formats/MatchCircuitModal.vue